import { utils, writeFile } from 'xlsx';

/**
 * 엑셀 다운로드
 * @param {Array[]} array 배열
 * @param {string} name 파일 이름
 * @param {number} [headerEnd=0] 헤더 끝 번호
 * @param {Object[]} [merges] 병합 목록
 * @param {Object} [merges[].s] 시작
 * @param {number} [merges[].s.c] 행 번호
 * @param {number} [merges[].s.r] 열 번호
 * @param {Object} [merges[].e] 끝
 * @param {number} [merges[].e.c] 행 번호
 * @param {number} [merges[].e.r] 열 번호
 */
function downloadExcelByArray(array = [], name, merges = []) {
  const workbook = utils.book_new();
  const worksheet = utils.aoa_to_sheet(array);

  if (Array.isArray(array[0])) {
    worksheet['!cols'] = array[0].map((value, index) => ({
      wch: array.reduce(
        (result, value = []) => Math.max(result, String(value[index]).length),
        10
      )
    }));
  }

  if (merges.length > 0) {
    worksheet['!merges'] = merges;
  }

  utils.book_append_sheet(workbook, worksheet);

  writeFile(workbook, name);
}

/**
 * 엑셀 다운로드
 * @param {JSON} json JSON
 * @param {string} name 파일 이름
 */
function downloadExcelByJSON(json = [], name) {
  const workbook = utils.book_new();
  const worksheet = utils.json_to_sheet(json);

  if (json.length > 0) {
    worksheet['!cols'] = Object.keys(json[0]).map(key => ({
      wch: json.reduce(
        (result, value = {}) => Math.max(result, String(value[key]).length),
        10
      )
    }));
  }

  utils.book_append_sheet(workbook, worksheet);

  writeFile(workbook, name);
}

/**
 * 엑셀 다운로드
 * @param {Element} table 테이블 DOM 요소
 * @param {string} name 파일 이름
 */
function downloadExcelByTable(table, name) {
  const workbook = utils.table_to_book(table, { raw: true });
  const [start, end] = workbook.Sheets[workbook.SheetNames[0]]['!ref']
    .split(':')
    .map(value => value.charCodeAt());

  workbook.Sheets[workbook.SheetNames[0]]['!cols'] = new Array(
    end - start + 1
  ).fill({ wch: 10 });

  writeFile(workbook, name);
}

/**
 * 파일 다운로드
 * @param {string} data 데이터
 * @param {string} name 파일 이름
 * @param {string} [type] 파일 구분
 */
function downloadFile(data, name, type) {
  const link = document.createElement('a');

  document.body.appendChild(
    Object.assign(link, {
      download: name,
      href: URL.createObjectURL(new Blob([data], { type }))
    })
  );

  link.click();
  link.remove();
}

export {
  downloadExcelByArray,
  downloadExcelByJSON,
  downloadExcelByTable,
  downloadFile
};
